<template>
  <div>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-card>
        <v-row>
          <v-col cols="4">
            <div class="pa-5">
              <v-file-input
                @change="gambar"
                accept="image/png, image/jpeg, image/bmp"
                :rules="[(v) => !!v || 'Tidak boleh kosong']"
                placeholder="Pilih gambar produk"
                prepend-icon="mdi-camera"
                label="Gambar Produk"
                required
              ></v-file-input>
            </div>
          </v-col>
          <v-col cols="3">
            <div>
              <b>Informasi Produk</b>
            </div>
            <div class="mt-5">
              <b>Nama Produk</b>
              <v-chip class="ma-2">Wajib</v-chip>
            </div>
            <div class="hint">
              Nama produk min. 5 kata dan terdiri dari jenis produk, merek, dan
              keterangan seperti warna, bahan, atau tipe.
            </div>
            <div class="mt-5">
              <b>Kategori</b>
              <v-chip class="ma-2">Wajib</v-chip>
            </div>
          </v-col>
          <v-col cols="5">
            <div class="white--text">.</div>
            <div class="mt-7">
              <v-text-field
                v-model="nama"
                label="Nama Produk"
                :rules="[(v) => !!v || 'Tidak boleh kosong']"
                placeholder="Contoh : Sepatu Pria (Jenis/Kategori) + Tokostore(Merek) + Kanvas Hitam (Keterangan)"
                :counter="70"
                class="mx-5"
                required
                outlined
              ></v-text-field>
            </div>
            <div class="mt-5">
              <v-autocomplete
                v-model="selKategori"
                required
                :items="kategori"
                item-value="id"
                item-text="nama_ktg"
                :rules="[(v) => !!v || 'Tidak boleh kosong']"
                class="mx-5"
                flat
                hide-no-data
                hide-details
                label="Pilih Kategori"
                solo-inverted
              ></v-autocomplete>
            </div>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="mt-5">
        <div class="pa-5">
          <b>Deskripsi Produk</b>
          <v-row>
            <v-col cols="3">
              <div class="my-5">
                <b>Kondisi</b>
              </div>
              <div class="my-5">
                <b>Stok</b>
                <div class="hint">Stok yang dimiliki toko saat ini</div>
              </div>
              <div class="my-5 mt-10">
                <b>Keterangan Produk</b>
                <div class="hint">
                  Cantumkan deskripsi lengkap sesuai produk, seperti keunggulan,
                  spesifikasi, material, ukuran, masa berlaku, dan lainnya.
                  Panjang deskripsi antara 450-2000 karakter.
                </div>
              </div>
            </v-col>
            <v-col cols="8">
              <div>
                <v-select
                  :items="kondisi"
                  v-model="selKondisi"
                  :rules="[(v) => !!v || 'Tidak boleh kosong']"
                  item-text="nama"
                  item-value="id"
                  label="Kondisi Barang"
                  required
                ></v-select>
              </div>
              <div>
                <v-text-field
                  v-model="stok"
                  label="Stok"
                  :rules="[(v) => !!v || 'Tidak boleh kosong']"
                  type="number"
                  outlined
                  required
                ></v-text-field>
              </div>
              <div>
                <v-textarea
                  v-model="desc"
                  :rules="[(v) => !!v || 'Tidak boleh kosong']"
                  solo
                  name="input-7-4"
                  label="Tambahkan Deskripsi Barang"
                  required
                ></v-textarea>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card>
      <v-card class="mt-5">
        <div class="pa-5">
          <b>Harga</b>
          <v-row>
            <v-col cols="3">
              <div class="my-5">
                <b>Harga</b>
                <v-chip class="ma-2">Wajib</v-chip>
              </div>
              <div class="my-5">
                <b>Minimum Pembelian</b>
              </div>
            </v-col>
            <v-col cols="8">
              <div class="mt-5">
                <v-text-field
                  v-model="harga"
                  :rules="[(v) => !!v || 'Tidak boleh kosong']"
                  required
                  dense
                  type="number"
                  label="Harga "
                  outlined
                ></v-text-field>
              </div>
              <div>
                <v-text-field
                  v-model="min_qty"
                  :rules="[(v) => !!v || 'Tidak boleh kosong']"
                  required
                  dense
                  type="number"
                  label="Minimal Pembelian "
                  outlined
                ></v-text-field>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card>
      <v-card class="mt-5">
        <div class="pa-5">
          <b>Berat & Pengiriman</b>
          <v-row>
            <v-col cols="3">
              <div class="my-5">
                <b>Berat</b>
                <v-chip class="ma-2">Wajib</v-chip>
                <div class="hint">
                  Produk ringan dengan ukuran yang besar hitung dengan Volume
                  Weight.
                </div>
              </div>
              <div class="my-5">
                <b>Asuransi</b>

                <div class="hint">Apakah anda menyediakan asuransi untuk barang tersebut</div>
              </div>
            </v-col>
            <v-col cols="8">
              <v-row>
                <v-col>
                  <div class="mt-5">
                    <v-text-field
                      v-model="berat"
                      :rules="[(v) => !!v || 'Tidak boleh kosong']"
                      required
                      dense
                      type="number"
                      label="Berat Barang"
                      outlined
                    ></v-text-field>
                  </div>
                </v-col>
                <v-col>
                  <div class="mt-5">
                    <v-select
                      class="mx-2"
                      :items="satuan"
                      v-model="selSatuan"
                      :rules="[(v) => !!v || 'Tidak boleh kosong']"
                      item-text="nama"
                      item-value="id"
                      label="Satuan"
                      dense
                      outlined
                      required
                    ></v-select>
                  </div>
                </v-col>
              </v-row>
              <div class="mt-5">
                <v-select
                  :items="asuransi"
                  v-model="selAsuransi"
                  :rules="[(v) => !!v || 'Tidak boleh kosong']"
                  item-text="nama"
                  item-value="id"
                  label="Asuransi"
                  dense
                  outlined
                  required
                ></v-select>
              </div>
            </v-col>
          </v-row>

          <v-btn @click="tambahProduk()" outlined medium>Tambah Barang</v-btn>
        </div>
      </v-card>
    </v-form>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import axios from "axios";
export default {
  data() {
    return {
      id: localStorage.getItem("user_id"),
      nama_toko: localStorage.getItem("nama_toko"),
      imgBarang: null,
      image: null,
      nama: null,
      stok: null,
      selKategori: null,
      selKondisi: null,
      selAsuransi: null,
      selSatuan: null,
      min_qty: null,
      desc: null,
      harga: null,
      berat: null,
      valid: true,
      kondisi: [
        {
          id: 1,
          nama: "Baru"
        },
        {
          id: 2,
          nama: "Bekas"
        }
      ],
      satuan: [
        {
          id: 1,
          nama: "gram"
        },
        {
          id: 2,
          nama: "kilogram"
        }
      ],
      asuransi: [
        {
          id: 1,
          nama: "Ya"
        },
        {
          id: 2,
          nama: "Tidak"
        }
      ],
      kategori: [
        {
          id: 1,
          nama_ktg: "Rumah Tangga"
        },
        {
          id: 2,
          nama_ktg: "Kebutuhan Anak"
        },
        {
          id: 3,
          nama_ktg: "Mainan"
        },
        {
          id: 4,
          nama_ktg: "Fashion"
        },
        {
          id: 5,
          nama_ktg: "Elektronik"
        },
        {
          id: 6,
          nama_ktg: "Gadget"
        }
      ]
    };
  },
  methods: {
    gambar(event) {
      this.image = event;

      this.imgBarang = this.image.name;
    },
    tambahProduk() {
      if (this.$refs.form.validate()) {
        this.overlay = true;
        const fd = new FormData();
        fd.append("filename", this.image, this.imgBarang);

        fetch("http://meridinet.saebo.id:2082/Login/api/tabel/addbarang", {
          method: "POST",
          body: JSON.stringify({
            userid: this.id,
            nama: this.nama,
            idkategori: this.selKategori,
            harga: this.harga,
            gambar: this.imgBarang,
            kondisi: this.selKondisi - 1,
            satuan: this.selSatuan - 1,
            berat: this.berat,
            desc: this.desc,
            nama_toko: this.nama_toko,
            kode_etalase: null,
            satuan_kecil: null,
            stok: this.stok,
            min_qty: this.min_qty,
            garansi: this.selAsuransi - 1
          }),
          headers: {
            "Content-type": "application/json",
            "Access-Control-Allow-Origin": "*"
          }
        })
          .then(response => response.json())
          .then(data => {
            console.log(data);
            if (data == 200) {
              axios
                .post(
                  "http://meridinet.saebo.id:2082/TestAPI/api/UploadFile/Upload",
                  fd
                )
                .then(res => {
                  console.log(res);
                });
              Swal.fire("Sukses", "Barang di posting", "success");
              window.history.back();
              this.overlay = false;
            } else {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Terjadi kendala jaringan"
              });
            }
          });
      }
    }
  }
};
</script>
<style scoped>
.hint {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 70%;
  letter-spacing: 0px;
  word-spacing: 2px;
  color: #000000;
  font-weight: normal;
  text-decoration: none;
  font-style: normal;
  font-variant: normal;
  text-transform: none;
}
</style>
